<template>
    <div>
        <div style="padding: 0 20px">
            <div class="top">
                <div>                    
                    <el-button type="primary" @click="addBanner()" style="width: 96px">新增</el-button>
                </div>
               
            </div>
            <div>
                <el-table :data="tableData"
                          v-loading="loading"
                          :header-cell-style="{'padding-left': '3%'}"
                          :cell-style="{'padding-left': '3%'}">
                    <el-table-column prop="id" label="ID"></el-table-column>                   
                    <el-table-column prop="bannerImage" label="图片路径">
                     <template slot-scope="scope">
                        <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                        <a :href="formatImage(scope.row.bannerImage)" target="_blank" title="查看最大化图片">
                            <img :src="formatImage(scope.row.bannerImage)" style="width: 300px;height: 300px">
                        </a>
                        <img slot="reference" :src="formatImage(scope.row.bannerImage)" style="width: 80px;height: 80px; cursor:pointer">
                        </el-popover>
                    </template>
                    </el-table-column>
                    <el-table-column prop="url" label="链接">
                         <template slot-scope="scope">
                            <span v-if="scope.row.url && scope.row.url.indexOf('.png') != -1">
                                <el-popover placement="top-start" trigger="click"> <!--trigger属性值：hover、click、focus 和 manual-->
                                <a :href="scope.row.url" target="_blank" title="查看最大化图片">
                                    <img :src="scope.row.url" style="width: 300px;height: 300px">
                                </a>
                                <img slot="reference" :src="scope.row.url" style="width: 80px;height: 80px; cursor:pointer">
                                </el-popover>
                            </span>
                            
                            <span v-else>{{scope.row.url}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">                        
                        <el-button type="text" @click="edit(scope.row)">查看</el-button>
                        <el-button type="text" @click="del(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>                                        
                    
                </el-table>
            </div>
    
        </div>
        <el-dialog title="新增轮播图" :visible.sync="dialogAddVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelAdd">
            <el-form :model="bannerAdd" ref="add" size="small" label-width="90px">

                <el-form-item label="标题:" prop="url">
                    <el-input v-model="bannerAdd.bannerTitle" style="width: 320px"></el-input>
                </el-form-item>


                <el-form-item label="链接:" prop="url">
                    <el-input v-model="bannerAdd.url" style="width: 320px"></el-input>
                </el-form-item>
               
                
               <el-form-item label="主图:" prop="bannerImage">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="bannerAdd.bannerImage"  class="course-img" :src="bannerAdd.bannerImage"></el-image>
                            <input type="file" class="upload-input" @change="addImg" accept="image/*" ref="picture"/>
                        </div>      
                </el-form-item>

                <el-form-item label="详情:" prop="url">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="bannerAdd.url"  class="course-img" :src="bannerAdd.url"></el-image>
                            <input type="file" class="upload-input" @change="addImgDetail" accept="image/*" ref="pictureDetail"/>
                        </div>      
                </el-form-item>

                <el-form-item label="对象:" prop="state">
                    <el-select size="small" style="width: 150px;margin-right: 20px" v-model="bannerAdd.state">
                        <el-option label="患者端" :value="0"></el-option>
                        <el-option label="医生端" :value="1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="flex-box"
                              prop="doctorType" v-if="bannerAdd.state==1">
                    <el-radio-group v-model="bannerAdd.doctorType" size="small">
                        <el-radio label="0">
                            平台医生
                        </el-radio>
                        <el-radio label="1">
                            诊所医生
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelAdd" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmAdd" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="编辑轮播图" :visible.sync="dialogEditVisible" width="560px"
                   :close-on-click-modal="false" :before-close="cancelEdit">
            <el-form :model="bannerEdit"  ref="edit" size="small" label-width="90px">

                <el-form-item label="标题:" prop="url">
                    <el-input v-model="bannerEdit.bannerTitle" style="width: 320px"></el-input>
                </el-form-item>

                <el-form-item label="链接:" prop="url">
                    <el-input v-model="bannerEdit.url" style="width: 320px"></el-input>
                </el-form-item>              
               
                
               <el-form-item label="主图:" prop="bannerImage">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="bannerEdit.bannerImage"  class="course-img" :src="formatImage(bannerEdit.bannerImage)"></el-image>
                            <input type="file" class="upload-input" @change="editImg" accept="image/*" ref="editPicture"/>
                        </div>      
                </el-form-item>

                <el-form-item label="详情:" prop="imagePath">
                       <div style="width: 92px;height: 92px;border:1px dashed rgba(204,204,204,1);">
                            <i class="el-icon-plus push"></i>
                            <el-image v-if="bannerEdit.url"  class="course-img" :src="bannerEdit.url"></el-image>
                            <input type="file" class="upload-input" @change="editImgDetail" accept="image/*" ref="editPictureDetail"/>
                        </div>      
                </el-form-item>

                <el-form-item label="对象:" prop="state">
                    <el-select size="small" style="width: 150px;margin-right: 20px" v-model="bannerEdit.state">
                        <el-option label="患者端" :value="0"></el-option>
                        <el-option label="医生端" :value="1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="flex-box"
                              prop="doctorType" v-if="bannerEdit.state==1">
                    <el-radio-group v-model="bannerEdit.doctorType" size="small">
                        <el-radio label="0">
                            平台医生
                        </el-radio>
                        <el-radio label="1">
                            诊所医生
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                            
               
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelEdit" style="width: 76px">取 消</el-button>
                <el-button type="primary" @click="confirmEdit" style="width: 76px;">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>    
    export default {
       
        data() {
            return {
                authorization:localStorage.getItem('authorization'),                
                loading: true,
                tableData: [],
                dialogAddVisible:false,
                doctorShow:false,
                doctorType:0,
                bannerAdd:{
                    bannerTitle:'',
                    state:0,
                    url:'',
                    bannerImage:'',
                    imagePath:'',
                    doctorType:''
                },
               
                dialogEditVisible:false,
                bannerEdit:{
                    bannerTitle:'',
                    id:'',
                    state:'',
                    url:'',
                    bannerImage:'',
                    imagePath:'',
                    doctorType:''
                }
                
               
            };
        },
        methods: {
            // 获取科室列表
            getData() {
                this.loading = true                
                this.axios.get('api-b/10055/100550/1',{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.code === 10000) {
                        if (res.data.data.length === 0) {
                            this.$message.info('暂无数据')
                        }
                        this.tableData = res.data.data
                        
                    } else {
                        this.$message.error(res.data.message)
                        this.tableData = []
                        
                    }
                    this.loading = false
                }).catch(error => {
                    this.tableData = []
                    
                    this.loading = false
                })
            },
           formatImage(imageurl) {
                let baseurl = "http://test.zgtyyy.com/chinesemedicine";                 
                return imageurl ? baseurl + imageurl : baseurl + "/src/images/default.png"
                
            },
            uploadImg(data) {
            return new Promise(resolve => {
                this.axios.post('/api-f/10027/100065',data,{
                    headers:{
                        Authorization: this.authorization,
                        'Content-Type':'multipart/form-data'
                    }
                }).then(res => {
                    resolve(res)
                })
            })
        },
        addImg(){
            let inputDOM = this.$refs.picture;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'bannerImage')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.bannerAdd.bannerImage = res.data.data.filePath
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        addImgDetail(){
            let inputDOM = this.$refs.pictureDetail;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'bannerImage')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.bannerAdd.url = res.data.data.fileUrl
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        // 修改图像
        editImg(){
            let inputDOM = this.$refs.editPicture;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'doctorProperty')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.bannerEdit.bannerImage = res.data.data.filePath
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        editImgDetail(){
            let inputDOM = this.$refs.editPictureDetail;
            let file = inputDOM.files[0];
            let params = new FormData()
            params.append('file',file)
            params.append("pathPrefix",'doctorProperty')
            this.uploadImg(params).then(res => {
                if (res.data.code === 10000) {
                    this.$message.success(res.data.message)
                    this.bannerEdit.url = res.data.data.fileUrl
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
        cancelAdd() {
            this.dialogAddVisible = false
            this.$nextTick(() => {
                this.$refs.add.resetFields()
            })
        },
        doctorChange(val) {
            var d_index = val.findIndex(item => item === '1')
            if (d_index >= 0) {
                this.doctorShow = true
            } else {
                this.doctorShow = false
            }
        },
        // 新增科室弹窗按钮
        addBanner() {            
            this.dialogAddVisible = true
        },
        confirmAdd(){
            this.$refs.add.validate(valid => {                                            
                let params = {
                    state:this.bannerAdd.state,
                    url:this.bannerAdd.url,
                    bannerImage:this.bannerAdd.bannerImage,
                    doctorType:this.bannerAdd.doctorType,
                    bannerTitle: this.bannerAdd.bannerTitle
                                                
                }
                this.axios.post('api-b/10055/100551/',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogAddVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                    
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                
            })

        },
        cancelEdit() {
                this.dialogEditVisible = false
                this.$nextTick(() => {
                    this.$refs.edit.clearValidate()
                })
            },
        // 编辑医生弹窗按钮
        edit(data) {
            
            this.axios.get('/api-b/10055/100553/' + data.id,{
            headers:{
                Authorization: this.authorization,
            }
            }).then(res => {
                
                if(res.data.code=== 10000) {
                    if (res.data.data !== null) {
                        this.dialogEditVisible = true
                        this.bannerEdit = res.data.data
                        
                    } else {
                        this.$message.info(res.data.message)
                    }
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },
            
        confirmEdit() {
            this.$refs.edit.validate(valid => {
                
                let params = {
                    id:this.bannerEdit.id,
                    url:this.bannerEdit.url,
                    bannerImage:this.bannerEdit.bannerImage,
                    doctorType:this.bannerEdit.doctorType,
                    bannerTitle: this.bannerEdit.bannerTitle
                }
                this.axios.post('/api-b/10055/100551',params,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.dialogEditVisible = false
                        this.$message.success(res.data.message)
                        this.getData()
                        this.$nextTick(() => {
                            this.$refs.edit.resetFields()                            
                        })
                    } else {
                        this.$message.error(res.data.message)
                    }
                })

               
            })
        },
       
        del(data){
            const h = this.$createElement;
            this.$msgbox({
                message: h('div',{class:'message-box'}, [
                    h('div', { class: 'message-title-box'}, [
                        h('i', { class:'el-icon-warning message-box-icon' }, ''),
                        h('span', { class:'message-box-title'}, '确认要删除该轮播图吗？'),
                    ]),
                    
                ]),
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {                
                
                this.axios.get('/api-b/10055/100552/' + data.id,{
                    headers:{
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        this.$message.success(res.data.message)
                        this.getData()
                    } else {
                        this.$message.error(res.data.message)
                        this.getData()
                    }
                }).catch(error => {})
            })

        }

           
        },
        watch: {
            
        },
        created() {
            this.getData()
        }
    };
</script>

<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 12px;
        height: 52px;
    }
    .delete-button {
        margin-left: 20px;
        color: rgba(255,75,75,1) !important;
    }
    .delete-button:hover {
        color: rgba(255,75,75,0.8) !important;
    }
    .delete-button:focus {
        color: rgba(215,37,41,1) !important;
    }
    .dialog-set{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .tag-box {
        width: 288px;
        min-height: 30px;
        border-radius: 5px;
        border: 1px solid #DCDFE6;
        padding: 0 15px
    }
    .push {
        color:rgba(238,238,238,1);
        font-size: 32px;
        position: absolute;
        top: 30px;
        left: 30px;
    }
    .course-img {
        position: absolute;
        top: 1px;
        width: 92px;
        height: 92px;
    }
     .upload-input {
        opacity: 0;
        width: 92px;
        height: 92px;
        position: absolute;
        top: 0;
    }
</style>